import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.USER_DETAILS_REQUEST}`,
            render: () => import("../../Pages/Core/Users/RequestNewUser/RequestNewUser.svelte"),
            title: "Request New User Account"
        }
    ]
};

export default routerConfig;